export const palette = {
  primary: '#2C2C2C',
  secondary: '#5C3426',
  accent: '#7BAEBF',
  backgroundPrimary: '#FAFAFA',
  backgroundSections: '#F0EBE6',
  border: '#C9B8AA',
  white: '#FFFFFF',
} as const
